/**
 * Learn more about theme events at
 * https://help.switchthemes.co/shapes/developer/theme-events/overview.html
 */

window.theme = window.theme || {};

window.theme.events = {
  version: '1.0',
};

(() => {
  const KL_TEASER_ATC_STORAGE_KEY = 'bim-hide-kl-teaser-SuL5sv';
  const CLASS_HIDE_ATC = 'kl-teaser-hide-atc';
  const CLASS_HIDE_RECHARGE = 'kl-teaser-hide-recharge-cart';

  function applyAtcClassFromStorage() {
    try {
      if (sessionStorage.getItem(KL_TEASER_ATC_STORAGE_KEY) === '1') {
        document.documentElement.classList.add(CLASS_HIDE_ATC);
      }
    } catch (_) {}
  }

  function persistAtcHidden() {
    try {
      sessionStorage.setItem(KL_TEASER_ATC_STORAGE_KEY, '1');
    } catch (_) {}
    document.documentElement.classList.add(CLASS_HIDE_ATC);
  }

  function isShopifyPaymentWalletClick(target) {
    return !!(target.closest && target.closest('.shopify-payment-button'));
  }

  function looksLikeCartAddForm(form) {
    if (!form) return false;
    if (
      form.hasAttribute('data-product-form') ||
      !!form.closest('[data-product-form]')
    ) {
      return true;
    }
    return !!(form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]'));
  }

  function isAddToCartInteraction(target) {
    if (!target.closest) return false;
    const submitButton = target.closest('button[type="submit"]');
    if (!submitButton) return false;
    const form = submitButton.closest('form[action*="/cart/add"]');
    if (!form) return false;
    return (
      submitButton.classList.contains('add-to-cart-btn') ||
      looksLikeCartAddForm(form)
    );
  }

  function onDocumentClickCapture(e) {
    if (isShopifyPaymentWalletClick(e.target)) return;
    if (isAddToCartInteraction(e.target)) {
      persistAtcHidden();
    }
  }

  function isThemeShapesModalSubtree(el) {
    return !!(el.closest && el.closest('[id^="modals-"]'));
  }

  function isRoughlyVisibleModal(el) {
    if (!(el instanceof Element)) return false;
    const style = window.getComputedStyle(el);
    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      Number(style.opacity) === 0
    ) {
      return false;
    }
    let rectOwner = el;
    if (el.tagName === 'DIALOG' && typeof el.showModal === 'function') {
      rectOwner = el;
    }
    const rects = rectOwner.getClientRects();
    return rects.length > 0;
  }

  function looksLikeRechargeContext(root) {
    if (!root || typeof root.querySelector !== 'function') return false;
    const idClass = `${root.id || ''} ${root.className || ''}`;
    if (/recharge/i.test(idClass)) return true;

    if (
      root.querySelector(
        'a[href*="rechargeapps.com"], a[href*="checkout.recharge"], a[href*="getrecharge.com"], iframe[src*="recharge"], iframe[src*="rechargeapps"], recharge-subscription-widget, .recharge-subscription-widget'
      )
    ) {
      return true;
    }

    try {
      const html = root.innerHTML;
      if (html.length > 250000) return false;
      if (/rechargeapps\.com|getrecharge\.com|checkout\.recharge/i.test(html)) {
        return true;
      }
    } catch (_) {}

    return false;
  }

  function syncRechargeCartOpenState() {
    let open = false;

    const candidates = [
      ...document.querySelectorAll('dialog[open]'),
      ...document.querySelectorAll('[role="dialog"][aria-modal="true"]'),
    ];

    const seen = new Set();
    for (const el of candidates) {
      if (seen.has(el)) continue;
      seen.add(el);
      if (isThemeShapesModalSubtree(el)) continue;
      if (!isRoughlyVisibleModal(el)) continue;
      if (looksLikeRechargeContext(el)) {
        open = true;
        break;
      }
    }

    document.documentElement.classList.toggle(CLASS_HIDE_RECHARGE, open);
  }

  function attachRechargeObserver() {
    const start = () => {
      syncRechargeCartOpenState();
      if (!document.body) return;
      let raf = null;
      const schedule = () => {
        if (raf != null) return;
        raf = window.requestAnimationFrame(() => {
          raf = null;
          syncRechargeCartOpenState();
        });
      };
      try {
        new MutationObserver(schedule).observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: [
            'open',
            'class',
            'aria-hidden',
            'aria-modal',
            'hidden',
          ],
        });
      } catch (_) {}
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  }

  applyAtcClassFromStorage();
  document.addEventListener('click', onDocumentClickCapture, true);
  attachRechargeObserver();
})();

document.addEventListener('theme:update:cart', async () => {
  document.dispatchEvent(new CustomEvent('shapes:cart:lock'));

  try {
    const response = await fetch(
      `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`
    );
    const data = await response.json();

    if (!data.status) {
      document.dispatchEvent(
        new CustomEvent('shapes:cart:update', {
          bubbles: true,
          detail: {
            response: {
              sections: {
                ...data,
              },
            },
          },
        })
      );
    }
  } catch (e) {
    console.error(e);
    document.getElementById('cart-errors').textContent =
      theme.strings.cartError;
    document.dispatchEvent(
      new CustomEvent('theme:cart:error:other', {
        detail: {
          message: theme.strings.cartError,
          error: e,
        },
      })
    );
  } finally {
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
  }
});

const getCartDrawerEl = () => {
  return document.querySelector('[data-cart-drawer]');
};

document.addEventListener('cart-will-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:opening', {
      detail,
    })
  );
});

document.addEventListener('cart-is-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:open', {
      detail,
    })
  );
});

document.addEventListener('cart-will-close', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closing', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('cart-is-closed', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closed', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('theme:open:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').closeAll();

    Alpine.store('modals').open('cart');
  }
});

document.addEventListener('theme:close:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').close('cart');
  }
});

const cartChangeEventHandler = (e) => {
  const { cartItemCount, itemsRootEl, lineItemEl, variantId, key } = e.detail;

  document.dispatchEvent(
    new CustomEvent('theme:cart:change', {
      detail: {
        type: e.type,
        cartItemCount,
        itemsRootEl,
        lineItemEl,
        variantId,
        key,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener('theme:product:add', cartChangeEventHandler);
document.addEventListener('theme:line-item:change', cartChangeEventHandler);

const cartErrorEventHandler = (e) => {
  document.dispatchEvent(
    new CustomEvent('theme:cart:error', {
      detail: {
        type: e.type,
        message: e.detail.message,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener(
  'theme:product:error:add-to-cart',
  cartErrorEventHandler
);

document.addEventListener('theme:line-item:error', cartErrorEventHandler);
document.addEventListener('theme:cart:error:other', cartErrorEventHandler);

/**
 * Set `window.themeEventsDebugMode` to `true` to log events
 * outside the theme editor
 */

if (Shopify.designMode || window.themeEventsDebugMode) {
  const themeEvents = [
    'theme:variant:change',
    'theme:product:add',
    'theme:line-item:change',
    'theme:cart:change',
    'theme:cart:update',
    'theme:cart-drawer:opening',
    'theme:cart-drawer:open',
    'theme:cart-drawer:closing',
    'theme:cart-drawer:closed',
    'theme:product:error:add-to-cart',
    'theme:line-item:error',
    'theme:cart:error:other',
    'theme:cart:error',
  ];

  const aggregateEvents = ['theme:cart:change', 'theme:cart:error'];

  for (const eventName of themeEvents) {
    let color;

    if (eventName.includes('error')) {
      color = '#ef4444';
    } else {
      color = '#22c55e';
    }

    const message = [
      `%c\u25CF %c${eventName}`,
      `color: ${color};`,
      'font-weight: bold;',
    ];

    if (aggregateEvents.includes(eventName)) {
      document.addEventListener(eventName, (e) => {
        console.groupCollapsed(...message);
        console.log(
          `Underlying event: %c${e.detail.type}`,
          'font-weight: bold;'
        );
        console.log('Event detail:', e.detail);
        console.groupEnd();
      });
    } else {
      document.addEventListener(eventName, (e) => {
        console.log(...message, e.detail);
      });
    }
  }
}
